import * as React from 'react';
import { useLocation } from 'react-router-dom';

import Helmet from '@/components/meta/Helmet';
import OptimizeTag from '@/components/meta/OptimizeTag';
import LpTemplate from '@/components/templates/Lp/Entry';
import { INVITER_PARAM_KEY } from '@/config/constants/query';
import { setInviterCookie } from '@/lib/invitation';

const LpPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const inviter = queryParams.get(INVITER_PARAM_KEY);

  if (inviter) {
    setInviterCookie(inviter);
  }

  const title = '新規登録＋ミッション達成で最大3,000円分ポイントプレゼント！';

  return (
    <>
      <Helmet
        meta={{
          title,
          description: `新規登録＋ミッション達成で最大3,000円分ポイントプレゼント！%s`,
          keywords: `新規登録,ポイントプレゼント,%s`,
          'og:image': `${
            import.meta.env.VITE_BASE_URL
          }/images/ogp/ogp_3000.png`,
        }}
      />
      <OptimizeTag />
      <LpTemplate inviter={inviter} />
    </>
  );
};

export default LpPage;
